import { Themes } from "@engaging-tech/components"

const fonts = {
  ...Themes.workL.fonts,
  sansSerif: "Albert Sans"
}

export const workLTheme = {
  ...Themes.workL,
  fonts
}

export const createFonts = () => ({
  ...fonts,
  serif: "Newsreader"
})
